import { createSlice } from '@reduxjs/toolkit';
import { handleGetRingCentral } from './ringCentralThunk';
import { IRingCentral } from '~/utils/interface/ring-central';

export interface RingCentralState {
  ringCentral?: IRingCentral;
}

const initialState: RingCentralState = {
  ringCentral: undefined,
};

const ringCentralSlice = createSlice({
  name: 'ringCentral',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(handleGetRingCentral.fulfilled, (state, action) => {
      state.ringCentral = { ...action.payload };
    });
  },
});

export const ringCentralActions = ringCentralSlice.actions;

const ringCentralReducer = ringCentralSlice.reducer;
export default ringCentralReducer;
